import { generatePath } from 'react-router-dom';
import { MYLEARNING_URL_FRAGMENT } from '../../constants/Navigation';
import { MY_LEARNING_TABS } from './myLearningTypes';
const myLearningTabs = MY_LEARNING_TABS.join('|');
export const MyLearningRoutePath = `${MYLEARNING_URL_FRAGMENT}/:tab(${myLearningTabs})?`;
export const getMyLearningUrl = tab => {
  return generatePath(MyLearningRoutePath, {
    tab
  });
};